import React, { useEffect } from 'react';
import { BsGithub, BsFileEarmarkPdf } from 'react-icons/bs';
import { FaEye, } from 'react-icons/fa';
import { FaReact, FaNodeJs, FaBootstrap } from 'react-icons/fa';
import { SiFirebase, SiReactrouter } from 'react-icons/si';


import img1 from '../../../images/project-details/learner-academy/resized/1.png';
import img2 from '../../../images/project-details/learner-academy/resized/2.png';
import img3 from '../../../images/project-details/learner-academy/resized/3.png';
import img4 from '../../../images/project-details/learner-academy/resized/4.png';
import img5 from '../../../images/project-details/learner-academy/resized/5.png';
import img6 from '../../../images/project-details/learner-academy/resized/6.png';
import book from '../../../images/project-details/learner-academy/book.gif';


import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';



import LearnerAcademyLarge from '../../../images/projects-large-image/LearnerAcademy.png';
import useTitle from '../../../Hooks/useTitle';






const LearnerAcademyDetails = () => {

    useTitle('Project | Learner Academy')

    useEffect(() => {
        AOS.init({
            duration: 1500
        })
    }, [])


    //details er 1st pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const divStyle = {
        backgroundImage: ` url(${LearnerAcademyLarge})`,
        transition: 'ease 4s'
    };
    const handleHover = () => {
        divStyle.transition = 'ease 4s'
    };
    const handleUnHover = () => {
        divStyle.transition = 'ease 1s'
    };





    return (
        <div>
            <div>

                {/* <h1 className='uppercase my-10 text-center text-3xl sm:text-3xl md:text-4xl lg:text-4xl animation' data-aos='flip-right'>Learner <span className='text-rose-600 text-6xl'>Academy</span></h1> */}

                <div className='flex justify-center items-center md:flex-row lg:flex-row sm:flex-col-reverse flex-col-reverse lg:mb-0 md:mb-0 sm:mb-8 mb-8 mt-16'>
                    <h1 className='uppercase text-center text-2xl sm:text-2xl md:text-3xl lg:text-3xl  animation lg:mt-0 md:mt-0 sm:-mt-10 -mt-10' data-aos='flip-right'>Learner <span className='text-rose-600 text-5xl'>Academy</span></h1>
                    <div className='ml-4'>
                        <div className="avatar lg:-mt-2 md:-mt-8 sm:mt-2 mt-2 lg:mb-0 md:mb-0 sm:mb-12 mb-12 ">
                            <div className="w-24 sm:w-24 md:w-28 lg:w-24 rounded-xl">
                                <img src={book} alt='bike' className='' />
                            </div>
                        </div>
                    </div>
                </div>


                <div className='grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 gap-x-10  gap-y-8 mt-8 mb-24 animation ' data-aos='zoom-in'>

                    <div className='lg:w-[460px] md:w-[335px] sm:w-[355px] w-[355px]  mx-auto' >
                        <div
                            style={divStyle}
                            onMouseEnter={handleHover}
                            onMouseLeave={handleUnHover}
                            className=" bg-top bg-cover  hover:bg-bottom rounded-lg  lg:w-[460px] lg:h-[308px] md:w-[330px] md:h-[220px] sm:w-[338px] sm:h-[220px] w-[338px] h-[220px] mx-auto"></div>
                    </div>


                    <div className="card  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img2} alt="car!" />

                    </div>

                    <div className="card  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">

                        <img className='rounded-lg ' src={img1} alt="car!" />
                    </div>

                    <div className="card  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">

                        <img className='rounded-lg ' src={img3} alt="car!" />

                    </div>

                    <div className="card mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">

                        <img className='rounded-lg ' src={img4} alt="car!" />

                    </div>

                    <div className="card   mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">

                        <img className='rounded-lg ' src={img5} alt="car!" />

                    </div>

                    <div className="card  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">

                        <img className='rounded-lg ' src={img6} alt="car!" />

                    </div>
                </div>

                <div>
                    <h1 className='uppercase my-10 text-center text-3xl sm:text-3xl md:text-5xl lg:text-5xl font-mono text-cyan-600 font-bold ' >Features & Source Code
                    </h1>

                    <div className="flex justify-evenly  lg:flex-row md:flex-col-reverse sm:flex-col-reverse flex-col-reverse lg:mx-0 md:mx-8 sm:mx-4 mx-3 mb-24 gap-x-10">

                        <div className="bg-gray-800 px-6 py-6 rounded-2xl shadow-2xl w-full sm:w-full md:w-full lg:w-2/4">

                            <h1 className='text-justify text-lg' > ⚪ Learner Academy is a online platform which provides different courses related to computer science and programming languages. There are some courses added in this project. A user can easily select a course based on his interest and can get the premium access also if he logged in.</h1> <br></br>

                            <h1 className='text-justify text-lg '> ⚪ This website is made by using React Router DOM, Firebase authentication is the major part of this project. Besides React Bootstrap is used for the styling purpose. Custom css is used where necessary. React toastify and sweet alert is added to show the alerts for better user experience. </h1> <br></br>

                            <h1 className='text-justify text-lg'> ⚪ In the client user can experience the smooth UI/UX of this project. User can choose the courses he/she wants to study. for the time being 6 courses has been added. many more will come soon. after selecting the course user can get enrolled in the course. Authentication is the most important part of the client side.</h1> <br></br>

                            <h1 className='text-justify text-lg'> ⚪ As this project is about online course providing for the students, I needed much data regarding the courses and course details. Fo that I have used node.js and express.js for the server purpose. I have created many data according to the courses and all the data are fetch from the client side. there is no static data in this project. </h1> <br></br>

                            <h1 className='text-justify text-lg'> ⚪ All the data are sent to the mongodb server. there is no static data in this project. This project is based on online used bike selling and For that I have added all the data to the Mongodb database and fetch the data when needed.</h1> <br></br>

                            <h1 className='text-justify text-lg'> ⚪ After the successful login user can get the access and will be redirected to the checkout page of the selected course, and he can also checkout if he wants. user can select multiple curses also. The checkout page contains the information about the user and the course which user has selected.</h1> <br></br>

                            <h1 className='text-justify text-lg'> ⚪ Authentication is an important part of the website. There are some routes that are private routes. Which means a user can not visit the route if he is not logged in. For the Authentication purpose I have used the google's Firebase authentication system. I have added some authentication systems. Email-Password Login and Google Login </h1>

                            <h1 className='text-justify text-lg'> ⚪ The Navbar of this projects shows the logged in user's information such as the name and the photo of the user. All these information are done by conditional rendering. If a user is not login to the website thn the nav bar will show the register and login options. user can toggle between these two.</h1>

                            <h1 className='text-justify text-lg'> ⚪ If someone wants to visit a route which is not available in the website then an error message will be shown. I have also implemented dark and light mode on the whole website based on the toggling button. PDF generator is added so that, user can print the course details he has applied for.</h1>

                        </div>


                        <div className='w-full sm:w-full md:w-full lg:w-2/4'>

                            <h2 className='text-center text-3xl mt-4 mb-12 '>GitHub Links <hr className='mx-auto mt-2 border-1 border-rose-500' width="180px" /></h2>

                            <div className=''>

                                {/* <a href='https://learner-academy.web.app/' target='blank' title='Live Site Demo'>

                                    <div className='bg-black border-2 border-teal-400  flex justify-center items-center rounded-lg px-8 gap-x-2 sm:mb-4 md:mb-0 lg:mb-0 mb-4 lg:w-full md:w-full sm:w-full w-full  hover:border-green-600 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 animation lg:mb-8 md:mb-8 sm:mb-8 mb-8' data-aos='fade-left'>

                                        <FaEye className='text-3xl mt-[3px] text-white'></FaEye>
                                        <button className='py-3 rounded-lg  text-white text-2xl  border-0 ' title='Visit Live Site'>Live Website</button>
                                    </div>
                                </a>

                                <a href='https://github.com/Fahimsakib1/learner-academy-client' target='blank' title='Client Side Code'>
                                    <div className='bg-black border-2 border-teal-400  flex justify-center items-center rounded-lg px-8 gap-x-2 sm:mb-4 md:mb-0 lg:mb-0 mb-4 lg:w-full md:w-full sm:w-full w-full hover:border-green-600 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 animation lg:mb-8 md:mb-8 sm:mb-8 mb-8' data-aos='fade-right'>

                                        <BsGithub className='text-3xl text-white'></BsGithub>
                                        <button className='py-3 rounded-lg text-white text-2xl  border-0 ' title='Client  Side Source Code'>Client Side Code</button>
                                    </div>
                                </a>

                                <a href='https://github.com/Fahimsakib1/learner-academy-server' target='blank' title='Server Side Code'>
                                    <div className='bg-black border-2 border-teal-400  flex justify-center items-center rounded-lg px-8 gap-x-2 sm:mb-4 md:mb-0 lg:mb-0 mb-4 lg:w-full md:w-full sm:w-full w-full hover:border-green-600 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 animation lg:mb-8 md:mb-8 sm:mb-8 mb-8 animation' data-aos='fade-left'>

                                        <BsGithub className='text-3xl text-white'></BsGithub>
                                        <button className='py-3 rounded-lg  text-white text-2xl  border-0 ' title='Server Side Source Code'>Server Side Code</button>
                                    </div>
                                </a> */}



                                <a href='https://learner-academy.web.app/' target='blank' title='Live Site Demo'>
                                    <div className='relative group mt-4 animation' data-aos='fade-left'>
                                        <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-gradient-to-r from-pink-600 to-violet-400 opacity-70 group-hover:opacity-90 transition duration-300 '>
                                        </div>
                                        <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                            <div className='flex space-x-3 justify-center items-center'>
                                                <span>Live Webssite</span>
                                                <FaEye className='text-3xl text-white'></FaEye>
                                            </div>
                                        </button>
                                    </div>
                                </a>




                                <a href='https://github.com/Fahimsakib1/learner-academy-client' target='blank' title='Client Side Code'>
                                    <div className='relative group mt-4 animation' data-aos='fade-right'>
                                        <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-blue-500 opacity-60 group-hover:opacity-90 transition duration-300 '>
                                        </div>
                                        <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                            <div className='flex space-x-3 justify-center items-center'>
                                                <span>Client Side Code</span>
                                                <BsGithub className='text-3xl text-white'></BsGithub>
                                            </div>
                                        </button>
                                    </div>
                                </a>



                                <a href='https://github.com/Fahimsakib1/learner-academy-server' target='blank' title='Server Side Code'>
                                    <div className='relative group mt-4 animation' data-aos='fade-left'>
                                        <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-green-500 opacity-60 group-hover:opacity-90 transition duration-300 '>
                                        </div>
                                        <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                            <div className='flex space-x-3 justify-center items-center'>
                                                <span>Server Side Code</span>
                                                <BsGithub className='text-3xl text-white'></BsGithub>
                                            </div>
                                        </button>
                                    </div>
                                </a>


                            </div>

                            <h2 className='text-center text-3xl mt-12 mb-8 '>Technologies Used <hr className='mx-auto mt-2 border-1 border-rose-500' width="180px" /></h2>

                            <div className='flex justify-center items-center flex-wrap  gap-x-8 lg:mb-0 md:mb-8 sm:mb-12 mb-12 animation' data-aos='fade-up'>

                                <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                    <FaReact className='text-4xl mx-2 text-cyan-500'></FaReact>
                                    <h1 className='text-white text-2xl py-2 ml-1 mr-4'>React JS</h1>
                                </div>

                                <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                    <FaNodeJs className='text-4xl mx-2 text-green-500'></FaNodeJs>
                                    <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Node JS</h1>
                                </div>

                                <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                    <SiFirebase className='text-4xl mx-2 text-yellow-400'></SiFirebase>
                                    <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Firebase</h1>
                                </div>

                                <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                    <SiReactrouter className='text-4xl mx-2 text-red-600'></SiReactrouter>
                                    <h1 className='text-white text-2xl py-2 ml-1 mr-4'>React Router</h1>
                                </div>

                                <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                    <FaBootstrap className='text-4xl mx-2 text-blue-600'></FaBootstrap>
                                    <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Bootstrap</h1>
                                </div>

                                <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                    <BsFileEarmarkPdf className='text-4xl mx-2 text-orange-400'></BsFileEarmarkPdf>
                                    <h1 className='text-white text-2xl py-2 ml-1 mr-4'>React PDF</h1>
                                </div>

                            </div>



                        </div>
                    </div>

                </div>




                {/* <div className='mx-auto text-center '>
                    <Link to='/'>
                        <button className='btn btn-primary w-[300px] sm:w-[300px] md:w-[400px] bg-black text-white text-xl border-2  hover:border-teal-500 border-violet-600 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 border-b-4 border-t-0 border-r-2 border-l-0 hover:bg-black hover:text-white'>Back To Home Page</button>
                    </Link>
                </div> */}


                <div className='mx-auto text-center my-10 '>
                    <Link to='/'>
                        <button className='cursor-pointer hover:scale-105 hover:duration-300 hover:ease-in-out hover:delay-150 px-6 py-2 rounded-sm  text-white text-lg mt-3 border-0 bg-blue-800' title='Download Resume'>
                            Back To Home Page
                        </button>
                    </Link>
                </div>




            </div>
        </div>
    );
};

export default LearnerAcademyDetails;